import { Inject, Injectable } from '@angular/core';

import { OneMirrorAuthenticationProvider } from 'src/app/utils/models/screen-mirroring.interface';
import { WINDOW } from 'src/app/utils/window.token';

export interface ScreenMirroringCredentials {
  devUserAccessToken?: string;
  authenticationProvider: OneMirrorAuthenticationProvider;
}

/**
 * Service for executing OWCC commands on the console
 */
@Injectable({
  providedIn: 'root'
})
export class ConsoleCommandService {
  public constructor(@Inject(WINDOW) private readonly window: Window) {
    this.window.owcc = this.window.owcc || {};
    this.window.owcc.cmd = this.window.owcc.cmd || {};
  }

  /**
   * Command to log in as an employee:
   * window.owcc.cmd.updateAuth('{"jwe":"xxx","claims":{"sub":"D0X12664","secondary_orgs":"D-Outlet.5832","dealer_home_org":"D-Outlet.5832","iss":"https://int.bias.oneweb.mercedes-benz.io","working_org_alias":"GS0000898","pi.sri":"C8A5QeNCsZZVltozNshzvvMDMdg.bW9l","group_type":"S","basic_start_authorization":"true","home_org":"D-Outlet.5832","personal_data_hint":"You have requested scopes allowing access to personal data. Be aware that you are not allowed to give personal data to other applications without permission by HR. Please request an access token without personal data scopes for accessing other applications. Personal data scopes are marked in the GAS-OIDC integration guide.","acr":"gas:standard","updated_at":20220307,"auth_time":1679991409,"home_org_alias":"GS0000898","entitlement_group":"OFLOGIN.RetailFeature","exp":1680013994,"app_id":"OFLOGIN","iat":1680012194,"email":"gems-testuser-int@mercedes-benz.com","jti":"82baf29a-8329-6ad4-d63b-03b9828feb99","tenant":"OFLOGIN","allow_from":"20220914","email_verified":false,"allow_to":"20230914","dealer_home_org_alias":"GS0000898","authorization_group":"OFLOGIN.AuthRole","org_ancestors":["D-Germany","D-Outlet.XC00000114","D-Country.DE","D-Outlet.GB00000001"],"given_name":"Testuser","working_org":"D-Outlet.5832","nonce":"n0UJ7CIxShHjtqkwrU0Xj8Lq1tEcMcNdOM4YASH-iXw","aud":"https://one-frontend.mercedes-benz.com","name":"Testuser D0X12664","family_name":"D0X12664"},"identityProvider":"BIAS","isPending":false,"profile":null,"alert":null}')
   */
  // TODO: Fix with MBCC-2658 - This needs a security review
  public onUpdateAuth(callback: (state: string) => void): void {
    this.assignOwccCmdProperty('updateAuth', (state: string): void => {
      callback(state);
    });
  }

  public onUpdateScreenMirroringCredentials(callback: (credentials: ScreenMirroringCredentials) => void): void {
    this.assignOwccCmdProperty('updateScreenMirroringCredentials', (credentials: ScreenMirroringCredentials): void => {
      callback(credentials);
    });
  }

  private assignOwccCmdProperty(name: string, value: unknown): void {
    if (this.window?.owcc?.cmd) {
      this.window.owcc.cmd[name] = value;
    }
  }
}
